// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yUFi","image":"Header_image__2Wyzo","name":"Header_name__2NI-a","info":"Header_info__34A1k","infoRow":"Header_infoRow__1nff1"};